// The documents' links — the user agreement, the policy of personal data, the consent — each opening its
// page (web/legal) in a tab of its own, and the version of the app: under the start card and in the profile.
// While the documents are hidden (legal.ts), the version alone.
import { DOCUMENTS, SHOWN } from "../legal.ts";
import { VERSION } from "../version.ts";

export function LegalLinks() {
  if (!SHOWN)
    return (
      <div class="legal-links">
        <span class="app-version">версия {VERSION}</span>
      </div>
    );
  return (
    <nav class="legal-links" aria-label="Документы">
      {DOCUMENTS.map((d) => (
        <a key={d.href} href={d.href} target="_blank" rel="noopener">
          {d.title}
        </a>
      ))}
      <span class="app-version">версия {VERSION}</span>
    </nav>
  );
}
